

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Navbar from '../components/Layout/Navbar';
// import { isAuthenticated } from '../utils/auth';
// import api from '../services/api';
// import './Pricing.css';

// interface PricingItem {
//   id: number;
//   service_name: string;
//   price: number;
//   description: string | null;
//   display_order: number;
// }

// interface PricingCategory {
//   id: number;
//   name: string;
//   display_order: number;
//   services: PricingItem[];
// }

// const Pricing: React.FC = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('Pricing');
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [successMessage, setSuccessMessage] = useState<string | null>(null);
  
//   const [pricingData, setPricingData] = useState<PricingCategory[]>([]);
//   const [expandedCategories, setExpandedCategories] = useState<{ [key: string]: boolean }>({});
  
//   const [editingItem, setEditingItem] = useState<{ categoryId: number; itemId: number; price: number } | null>(null);
//   const [editPrice, setEditPrice] = useState('');
  
//   const [showAddCategory, setShowAddCategory] = useState(false);
//   const [newCategoryName, setNewCategoryName] = useState('');
//   const [showAddItem, setShowAddItem] = useState<number | null>(null);
//   const [newItemName, setNewItemName] = useState('');
//   const [newItemPrice, setNewItemPrice] = useState('');

//   const fetchPricing = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await api.get('/admin/pricing');
//       if (response.data.success) {
//         setPricingData(response.data.data);
//         const expanded: { [key: string]: boolean } = {};
//         response.data.data.forEach((category: PricingCategory) => {
//           expanded[category.name] = true;
//         });
//         setExpandedCategories(expanded);
//       } else {
//         setError('Failed to load pricing data');
//       }
//     } catch (err: any) {
//       console.error('Error fetching pricing:', err);
//       setError(err.response?.data?.error || 'Failed to load pricing');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const savePricing = async (updatedData: PricingCategory[]) => {
//     setSaving(true);
//     setError(null);
//     try {
//       const payload = {
//         categories: updatedData.map(category => ({
//           id: category.id,
//           name: category.name,
//           display_order: category.display_order,
//           is_active: true,
//           services: category.services.map(service => ({
//             id: service.id,
//             service_name: service.service_name,
//             price: service.price,
//             description: service.description,
//             display_order: service.display_order,
//             is_active: true
//           }))
//         }))
//       };
      
//       const response = await api.put('/admin/pricing', payload);
//       if (response.data.success) {
//         setSuccessMessage('Pricing updated successfully!');
//         setTimeout(() => setSuccessMessage(null), 3000);
//         await fetchPricing();
//       } else {
//         setError(response.data.message || 'Failed to save pricing');
//       }
//     } catch (err: any) {
//       console.error('Error saving pricing:', err);
//       setError(err.response?.data?.error || 'Error saving pricing');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleCategory = (categoryName: string) => {
//     setExpandedCategories(prev => ({
//       ...prev,
//       [categoryName]: !prev[categoryName]
//     }));
//   };

//   const handleEditPrice = (categoryId: number, itemId: number, currentPrice: number) => {
//     setEditingItem({ categoryId, itemId, price: currentPrice });
//     setEditPrice(currentPrice.toString());
//   };

//   const handleSavePrice = async () => {
//     if (!editingItem) return;
    
//     const newPrice = parseFloat(editPrice);
//     if (isNaN(newPrice) || newPrice < 0) {
//       setError('Please enter a valid price');
//       return;
//     }
    
//     const updatedData = pricingData.map(category => {
//       if (category.id === editingItem.categoryId) {
//         return {
//           ...category,
//           services: category.services.map(service => {
//             if (service.id === editingItem.itemId) {
//               return { ...service, price: newPrice };
//             }
//             return service;
//           })
//         };
//       }
//       return category;
//     });
    
//     setPricingData(updatedData);
//     await savePricing(updatedData);
//     setEditingItem(null);
//     setEditPrice('');
//   };

//   const handleCancelEdit = () => {
//     setEditingItem(null);
//     setEditPrice('');
//   };

//   const handleAddCategory = async () => {
//     if (!newCategoryName.trim()) {
//       setError('Please enter a category name');
//       return;
//     }
    
//     const newCategory: PricingCategory = {
//       id: 0,
//       name: newCategoryName.trim(),
//       display_order: pricingData.length + 1,
//       services: []
//     };
    
//     const updatedData = [...pricingData, newCategory];
//     setPricingData(updatedData);
//     await savePricing(updatedData);
//     setShowAddCategory(false);
//     setNewCategoryName('');
//   };

//   const handleAddItem = async (categoryId: number) => {
//     if (!newItemName.trim()) {
//       setError('Please enter a service name');
//       return;
//     }
    
//     const newPrice = parseFloat(newItemPrice);
//     if (isNaN(newPrice) || newPrice < 0) {
//       setError('Please enter a valid price');
//       return;
//     }
    
//     const updatedData = pricingData.map(category => {
//       if (category.id === categoryId) {
//         const newService: PricingItem = {
//           id: 0,
//           service_name: newItemName.trim(),
//           price: newPrice,
//           description: null,
//           display_order: category.services.length + 1
//         };
//         return {
//           ...category,
//           services: [...category.services, newService]
//         };
//       }
//       return category;
//     });
    
//     setPricingData(updatedData);
//     await savePricing(updatedData);
//     setShowAddItem(null);
//     setNewItemName('');
//     setNewItemPrice('');
//   };

//   const handleDeleteCategory = async (categoryId: number, categoryName: string) => {
//     if (window.confirm(`Are you sure you want to delete "${categoryName}" category?`)) {
//       const updatedData = pricingData.filter(category => category.id !== categoryId);
//       setPricingData(updatedData);
//       await savePricing(updatedData);
//     }
//   };

//   const handleDeleteItem = async (categoryId: number, itemId: number, itemName: string) => {
//     if (window.confirm(`Are you sure you want to delete "${itemName}"?`)) {
//       const updatedData = pricingData.map(category => {
//         if (category.id === categoryId) {
//           return {
//             ...category,
//             services: category.services.filter(service => service.id !== itemId)
//           };
//         }
//         return category;
//       });
//       setPricingData(updatedData);
//       await savePricing(updatedData);
//     }
//   };

//   useEffect(() => {
//     fetchPricing();
//   }, []);

//   const handleTabChange = (tab: string) => {
//     setActiveTab(tab);
//     const routes: { [key: string]: string } = {
//       'Dashboard': '/dashboard',
//       'Calls': '/calls',
//       'Conversations': '/conversations',
//       'Transcriptions': '/transcriptions',
//       'Timings': '/timings',
//       'Doctors': '/doctors',
//       'Pricing': '/pricing',
//       'Appointments': '/appointments',
//       'EmailConfig': '/emailconfig'
//     };
//     navigate(routes[tab] || '/dashboard');
//   };

//   if (!isAuthenticated()) return null;

//   if (loading) {
//     return (
//       <div className="pricing-page">
//         <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//         <div className="page-content">
//           <div className="page-header">
//             <h1>💰 Pricing Management</h1>
//           </div>
//           <div style={{ textAlign: 'center', padding: '50px' }}>Loading pricing data...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="pricing-page">
//       <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//       <div className="page-content">
//         <div className="page-header">
//           <h1>💰 Pricing Management</h1>
//           <div className="header-actions">
//             {saving && <span className="saving-badge">Saving...</span>}
//             <button 
//               className="add-category-btn"
//               onClick={() => setShowAddCategory(true)}
//               disabled={saving}
//             >
//               + New Category
//             </button>
//           </div>
//         </div>

//         {successMessage && (
//           <div className="alert-success">
//             <span>✅</span> {successMessage}
//           </div>
//         )}

//         {error && (
//           <div className="alert-error">
//             <span>❌</span> {error}
//             <button onClick={() => setError(null)} className="alert-close">×</button>
//           </div>
//         )}

//         {showAddCategory && (
//           <div className="add-category-card">
//             <input
//               type="text"
//               value={newCategoryName}
//               onChange={(e) => setNewCategoryName(e.target.value)}
//               placeholder="Enter category name..."
//               onKeyPress={(e) => e.key === 'Enter' && handleAddCategory()}
//               autoFocus
//             />
//             <button onClick={handleAddCategory} disabled={saving}>Save</button>
//             <button onClick={() => { setShowAddCategory(false); setNewCategoryName(''); }}>Cancel</button>
//           </div>
//         )}

//         <div className="pricing-container">
//           {pricingData.map((category) => (
//             <div key={category.id} className="pricing-card">
//               <div 
//                 className="pricing-card-header"
//                 onClick={() => toggleCategory(category.name)}
//               >
//                 <div className="header-left">
//                   <span className={`expand-icon ${expandedCategories[category.name] ? 'expanded' : ''}`}>
//                     {expandedCategories[category.name] ? '▼' : '▶'}
//                   </span>
//                   <h3>{category.name}</h3>
//                 </div>
//                 <button 
//                   className="delete-category-btn"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleDeleteCategory(category.id, category.name);
//                   }}
//                   title="Delete Category"
//                   disabled={saving}
//                 >
//                   🗑️
//                 </button>
//               </div>

//               {expandedCategories[category.name] && (
//                 <div className="pricing-card-body">
//                   <table className="pricing-table">
//                     <thead>
//                       <tr>
//                         <th>Service</th>
//                         <th className="price-col">Price</th>
//                         <th className="actions-col">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {category.services.map((item) => (
//                         <tr key={item.id}>
//                           <td className="service-name">{item.service_name}</td>
//                           <td className="price-cell">
//                             {editingItem?.categoryId === category.id && editingItem?.itemId === item.id ? (
//                               <div className="edit-price-container">
//                                 <span className="dollar-sign">$</span>
//                                 <input
//                                   type="number"
//                                   value={editPrice}
//                                   onChange={(e) => setEditPrice(e.target.value)}
//                                   className="price-input"
//                                   step="0.01"
//                                   min="0"
//                                   autoFocus
//                                 />
//                                 <button className="icon-btn save" onClick={handleSavePrice} disabled={saving}>✓</button>
//                                 <button className="icon-btn cancel" onClick={handleCancelEdit}>✕</button>
//                               </div>
//                             ) : (
//                               <span className="price-value">${item.price.toFixed(2)}</span>
//                             )}
//                           </td>
//                           <td className="actions-cell">
//                             {!editingItem && (
//                               <>
//                                 <button 
//                                   className="icon-btn edit"
//                                   onClick={() => handleEditPrice(category.id, item.id, item.price)}
//                                   title="Edit Price"
//                                   disabled={saving}
//                                 >
//                                   ✏️
//                                 </button>
//                                 <button 
//                                   className="icon-btn delete"
//                                   onClick={() => handleDeleteItem(category.id, item.id, item.service_name)}
//                                   title="Delete Service"
//                                   disabled={saving}
//                                 >
//                                   🗑️
//                                 </button>
//                               </>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>

//                   {showAddItem === category.id ? (
//                     <div className="add-item-form">
//                       <input
//                         type="text"
//                         value={newItemName}
//                         onChange={(e) => setNewItemName(e.target.value)}
//                         placeholder="Service name..."
//                         className="item-name-input"
//                       />
//                       <input
//                         type="number"
//                         value={newItemPrice}
//                         onChange={(e) => setNewItemPrice(e.target.value)}
//                         placeholder="Price"
//                         className="item-price-input"
//                         step="0.01"
//                         min="0"
//                       />
//                       <button className="add-btn" onClick={() => handleAddItem(category.id)} disabled={saving}>Add</button>
//                       <button className="cancel-btn" onClick={() => { setShowAddItem(null); setNewItemName(''); setNewItemPrice(''); }}>Cancel</button>
//                     </div>
//                   ) : (
//                     <button 
//                       className="add-service-btn"
//                       onClick={() => setShowAddItem(category.id)}
//                       disabled={saving}
//                     >
//                       + Add Service
//                     </button>
//                   )}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Pricing;




import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import { isAuthenticated } from '../utils/auth';
import api from '../services/api';
import PricingFormModal from '../components/Admin/PricingFormModal';
import './Pricing.css';

interface PricingItem {
  id: number;
  service_name: string;
  price: number;
  description: string | null;
  display_order: number;
}

interface PricingCategory {
  id: number;
  name: string;
  display_order: number;
  services: PricingItem[];
}

const Pricing: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Pricing');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  
  const [pricingData, setPricingData] = useState<PricingCategory[]>([]);
  const [expandedCategories, setExpandedCategories] = useState<{ [key: string]: boolean }>({});
  
  // Modal states
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState<PricingCategory | null>(null);
  const [editingService, setEditingService] = useState<{ category: PricingCategory; service: PricingItem } | null>(null);
  const [targetCategoryId, setTargetCategoryId] = useState<number | null>(null);

  const fetchPricing = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/admin/pricing');
      if (response.data.success) {
        setPricingData(response.data.data);
        const expanded: { [key: string]: boolean } = {};
        response.data.data.forEach((category: PricingCategory) => {
          expanded[category.name] = true;
        });
        setExpandedCategories(expanded);
      } else {
        setError('Failed to load pricing data');
      }
    } catch (err: any) {
      console.error('Error fetching pricing:', err);
      setError(err.response?.data?.error || 'Failed to load pricing');
    } finally {
      setLoading(false);
    }
  };

  const savePricing = async (updatedData: PricingCategory[]) => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        categories: updatedData.map(category => ({
          id: category.id,
          name: category.name,
          display_order: category.display_order,
          is_active: true,
          services: category.services.map(service => ({
            id: service.id,
            service_name: service.service_name,
            price: service.price,
            description: service.description,
            display_order: service.display_order,
            is_active: true
          }))
        }))
      };
      
      const response = await api.put('/admin/pricing', payload);
      if (response.data.success) {
        setSuccessMessage('Pricing updated successfully!');
        setTimeout(() => setSuccessMessage(null), 3000);
        await fetchPricing();
      } else {
        setError(response.data.message || 'Failed to save pricing');
      }
    } catch (err: any) {
      console.error('Error saving pricing:', err);
      setError(err.response?.data?.error || 'Error saving pricing');
    } finally {
      setSaving(false);
    }
  };

  const toggleCategory = (categoryName: string) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryName]: !prev[categoryName]
    }));
  };

  // Category Handlers
  const handleAddCategory = () => {
    setEditingCategory(null);
    setShowCategoryModal(true);
  };

  const handleEditCategory = (category: PricingCategory) => {
    setEditingCategory(category);
    setShowCategoryModal(true);
  };

  const handleSaveCategory = async (categoryData: { name: string; display_order: number }) => {
    let updatedData: PricingCategory[];
    
    if (editingCategory) {
      // Update existing category
      updatedData = pricingData.map(cat => 
        cat.id === editingCategory.id 
          ? { ...cat, name: categoryData.name, display_order: categoryData.display_order }
          : cat
      );
    } else {
      // Add new category
      const newCategory: PricingCategory = {
        id: 0,
        name: categoryData.name,
        display_order: categoryData.display_order,
        services: []
      };
      updatedData = [...pricingData, newCategory];
    }
    
    setPricingData(updatedData);
    await savePricing(updatedData);
    setShowCategoryModal(false);
    setEditingCategory(null);
  };

  const handleDeleteCategory = async (categoryId: number, categoryName: string) => {
    if (window.confirm(`Are you sure you want to delete "${categoryName}" category? All services in this category will also be deleted.`)) {
      const updatedData = pricingData.filter(category => category.id !== categoryId);
      setPricingData(updatedData);
      await savePricing(updatedData);
    }
  };

  // Service Handlers
  const handleAddService = (categoryId: number) => {
    setTargetCategoryId(categoryId);
    setEditingService(null);
    setShowServiceModal(true);
  };

  const handleEditService = (category: PricingCategory, service: PricingItem) => {
    setEditingService({ category, service });
    setShowServiceModal(true);
  };

  const handleSaveService = async (serviceData: { service_name: string; price: number; description: string; display_order: number }) => {
    let updatedData: PricingCategory[];
    
    if (editingService) {
      // Update existing service
      updatedData = pricingData.map(cat => {
        if (cat.id === editingService.category.id) {
          return {
            ...cat,
            services: cat.services.map(service => 
              service.id === editingService.service.id
                ? { ...service, ...serviceData }
                : service
            )
          };
        }
        return cat;
      });
    } else {
      // Add new service
      updatedData = pricingData.map(cat => {
        if (cat.id === targetCategoryId) {
          const newService: PricingItem = {
            id: 0,
            service_name: serviceData.service_name,
            price: serviceData.price,
            description: serviceData.description,
            display_order: cat.services.length + 1
          };
          return {
            ...cat,
            services: [...cat.services, newService]
          };
        }
        return cat;
      });
    }
    
    setPricingData(updatedData);
    await savePricing(updatedData);
    setShowServiceModal(false);
    setEditingService(null);
    setTargetCategoryId(null);
  };

  const handleDeleteService = async (categoryId: number, itemId: number, itemName: string) => {
    if (window.confirm(`Are you sure you want to delete "${itemName}"?`)) {
      const updatedData = pricingData.map(category => {
        if (category.id === categoryId) {
          return {
            ...category,
            services: category.services.filter(service => service.id !== itemId)
          };
        }
        return category;
      });
      setPricingData(updatedData);
      await savePricing(updatedData);
    }
  };

  useEffect(() => {
    fetchPricing();
  }, []);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    const routes: { [key: string]: string } = {
      'Dashboard': '/dashboard',
      'Calls': '/calls',
      'Conversations': '/conversations',
      'Transcriptions': '/transcriptions',
      'Timings': '/timings',
      'Doctors': '/doctors',
      'Pricing': '/pricing',
      'Appointments': '/appointments',
      'EmailConfig': '/emailconfig'
    };
    navigate(routes[tab] || '/dashboard');
  };

  if (!isAuthenticated()) return null;

  if (loading) {
    return (
      <div className="pricing-page">
        <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
        <div className="page-content">
          <div className="page-header">
            <h1>💰 Pricing Management</h1>
          </div>
          <div style={{ textAlign: 'center', padding: '50px' }}>Loading pricing data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="pricing-page">
      <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="page-content">
        <div className="page-header">
          <h1>💰 Pricing Management</h1>
          <div className="header-actions">
            {saving && <span className="saving-badge">Saving...</span>}
            <button 
              className="add-category-btn"
              onClick={handleAddCategory}
              disabled={saving}
            >
              + New Category
            </button>
          </div>
        </div>

        {successMessage && (
          <div className="alert-success">
            <span>✅</span> {successMessage}
          </div>
        )}

        {error && (
          <div className="alert-error">
            <span>❌</span> {error}
            <button onClick={() => setError(null)} className="alert-close">×</button>
          </div>
        )}

        <div className="pricing-container">
          {pricingData.map((category) => (
            <div key={category.id} className="pricing-card">
              <div 
                className="pricing-card-header"
                onClick={() => toggleCategory(category.name)}
              >
                <div className="header-left">
                  <span className={`expand-icon ${expandedCategories[category.name] ? 'expanded' : ''}`}>
                    {expandedCategories[category.name] ? '▼' : '▶'}
                  </span>
                  <h3>{category.name}</h3>
                </div>
                <div className="header-actions-right">
                  <button 
                    className="edit-category-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditCategory(category);
                    }}
                    title="Edit Category"
                    disabled={saving}
                  >
                    ✏️
                  </button>
                  <button 
                    className="delete-category-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteCategory(category.id, category.name);
                    }}
                    title="Delete Category"
                    disabled={saving}
                  >
                    🗑️
                  </button>
                </div>
              </div>

              {expandedCategories[category.name] && (
                <div className="pricing-card-body">
                  <table className="pricing-table">
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th className="price-col">Price</th>
                        <th className="actions-col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {category.services.map((item) => (
                        <tr key={item.id}>
                          <td className="service-name">{item.service_name}</td>
                          <td className="price-cell">
                            <span className="price-value">${item.price.toFixed(2)}</span>
                          </td>
                          <td className="actions-cell">
                            <button 
                              className="icon-btn edit"
                              onClick={() => handleEditService(category, item)}
                              title="Edit Service"
                              disabled={saving}
                            >
                              ✏️
                            </button>
                            <button 
                              className="icon-btn delete"
                              onClick={() => handleDeleteService(category.id, item.id, item.service_name)}
                              title="Delete Service"
                              disabled={saving}
                            >
                              🗑️
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <button 
                    className="add-service-btn"
                    onClick={() => handleAddService(category.id)}
                    disabled={saving}
                  >
                    + Add Service
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Category Modal */}
      <PricingFormModal
        isOpen={showCategoryModal}
        type="category"
        title={editingCategory ? 'Edit Category' : 'Add New Category'}
        initialData={editingCategory ? { name: editingCategory.name, display_order: editingCategory.display_order } : undefined}
        onSave={handleSaveCategory}
        onClose={() => {
          setShowCategoryModal(false);
          setEditingCategory(null);
        }}
      />

      {/* Service Modal */}
      <PricingFormModal
        isOpen={showServiceModal}
        type="service"
        title={editingService ? 'Edit Service' : 'Add New Service'}
        initialData={editingService ? { 
          service_name: editingService.service.service_name, 
          price: editingService.service.price,
          description: editingService.service.description || '',
          display_order: editingService.service.display_order 
        } : undefined}
        onSave={handleSaveService}
        onClose={() => {
          setShowServiceModal(false);
          setEditingService(null);
          setTargetCategoryId(null);
        }}
      />
    </div>
  );
};

export default Pricing;